import { JackpotCounters } from "./Counters";
import { JackpotDetailsFrame } from "./JackpotDetailsFrame";
// import { GameData } from "../../gamestate/gameData";
import { createMovieClip } from "../../functions/Functions_General";
import { CommonData } from "../../datastructures/gamestate/gameData";

export class jackPotLabel {
  private counter: JackpotCounters;
  private detailsPanel: JackpotDetailsFrame;

  private parent: PIXI.Container;
  private background: PIXI.Sprite;
  private label: PIXI.Text;
  private currency: PIXI.Text;
  private labelStyle: PIXI.TextStyle;
  private currencyStyle: PIXI.TextStyle;
  private jackpotExtentIcon: PIXI.Sprite;
  private activeGameData: any;
  private animation: PIXI.extras.AnimatedSprite;
  constructor(
    parent: PIXI.Container,
    label: string,
    activeGameData: CommonData,
    counterLength: number
  ) {
    this.parent = new PIXI.Container();
    parent.addChild(this.parent);
    this.activeGameData = activeGameData;

    this.background = new PIXI.Sprite(
      PIXI.Texture.fromImage("jackpot_txt_bg.png")
    );

    this.makeClickable(true);

    this.parent.addChild(this.background);

    this.labelStyle = new PIXI.TextStyle({
      fontFamily: activeGameData.gameTextStyle.gameFont,
      fontSize: 35,
      fill: ["#b98a58", "#b98a58", "#ffc880"],
      fontWeight: "bold",
      lineHeight: 30,
      align: "center",
      stroke: "#ffffbc",
      strokeThickness: 0,
      dropShadow: true,
      dropShadowColor: "#000000",
      // dropShadowBlur: 10,
      dropShadowAngle: Math.PI / 6,
      dropShadowDistance: 0,
    });

    this.currencyStyle = new PIXI.TextStyle({
      fontFamily: activeGameData.gameTextStyle.gameFont,
      fontSize: 20,
      fill: ["#b98a58", "#b98a58", "#ffc880"],
      fontWeight: "bold",
      lineHeight: 30,
      align: "center",
      stroke: "#ffffbc",
      strokeThickness: 0,
      dropShadow: true,
      dropShadowColor: "#000000",
      // dropShadowBlur: 10,
      dropShadowAngle: Math.PI / 6,
      dropShadowDistance: 0,
    });

    this.label = new PIXI.Text(label, this.labelStyle);
    this.currency = new PIXI.Text(activeGameData.currency, this.currencyStyle);
    this.counter = new JackpotCounters(100, counterLength, activeGameData);

    this.parent.addChild(this.label);
    this.parent.addChild(this.currency);
    this.label.y = 0; //this.label.height;
    this.label.x = 10;
    this.currency.x = this.background.width - this.currency.width;
    this.currency.y = 0;
    this.counter.setChildOf(this.parent);
    this.counter.setPosition(
      this.background.width -
        this.counter.getTextWidth() -
        this.currency.width * 1.1,
      0
    );
    this.jackpotExtentIcon = new PIXI.Sprite(
      PIXI.Texture.fromImage("jackpot_extend.png")
    );
    this.parent.addChild(this.jackpotExtentIcon);
    this.jackpotExtentIcon.x =
      this.background.width - this.jackpotExtentIcon.width;
    this.jackpotExtentIcon.y = 35;
    this.detailsPanel = new JackpotDetailsFrame(
      this.parent,
      this.background.width,
      this.activeGameData
    );
    // this.detailsPanel.update();
    this.background.on("pointertap", this.click);

    this.animation = createMovieClip("jackpotLabelLight", 0, 13);
    this.animation.anchor.set(0.5);
    this.animation.x = this.animation.width / 2 - 25;
    this.animation.animationSpeed = 0.25;
    this.animation.y = this.animation.height / 2 - 25;
    this.background.addChild(this.animation);
    this.animation.blendMode = PIXI.BLEND_MODES.ADD;
    this.animation.loop = false;
    this.animation.play();
  }
  public setAvailable = (bool: boolean): void => {
    this.counter.setAvailable(bool);
    this.detailsPanel.setAvailable(bool);
  };
  private makeClickable = (bool: boolean): void => {
    this.background.interactive = bool;
    this.background.buttonMode = bool;
    this.setHitArea();
  };

  private setHitArea = (): void => {
    if (this.activeGameData.isMobile) {
      if (this.activeGameData.isIphone) {
        //way bigger hitbox for iphone than desktop
        this.background.hitArea = new PIXI.Rectangle(
          0,
          0,
          this.background.width,
          this.background.height + 70
        );
      } else {
        // slightly bigger hitbox than deskop
        this.background.hitArea = new PIXI.Rectangle(
          0,
          0,
          this.background.width,
          this.background.height + 55
        );
      }
    }

    // if(this.isPortraitMode)
    // {
    //     //--
    //     this.background.hitArea = new PIXI.Rectangle(0, 0, this.background.width, this.background.height + 70);
    // }
  };
  private click = (): void => {
    this.detailsPanel.onClick();
  };
  public setNewValue = (newValue: number): void => {
    this.counter.setAnimationTargetValue(newValue);
  };

  public getCurrentValue = (): number => {
    return this.counter.getTargetedValue();
  };

  public setInitialValue = (newValue: number): void => {
    // this.counter.setInitalValue(newValue);
    this.counter.setInitialValue(newValue);
  };
  public setPosition = (x: number, y: number): void => {
    this.parent.x = x;
    this.parent.y = y;
  };

  public setWidth = (val: number): void => {
    this.background.width = val;
    this.counter.setPosition(
      this.background.width -
        this.counter.getTextWidth() -
        this.currency.width * 1.1,
      0
    );
    this.currency.x = this.background.width - this.currency.width;
    this.jackpotExtentIcon.x =
      this.background.width - this.jackpotExtentIcon.width;
  };

  public setLabelText = (label: string): void => {
    this.label.text = label;
  };

  public playShineAnimation = (): void => {
    this.animation.gotoAndPlay(0);
  };

  public setScale = (scale: number): void => {
    this.parent.scale.set(scale);
  };

  public getWidth = (): number => {
    return this.background.width;
  };

  public getParent = (): PIXI.Container => {
    return this.parent;
  };

  public getBG = (): PIXI.Sprite => {
    return this.background;
  };

  public setButtonMode = (bool: boolean): void => {
    this.background.interactive = bool;
    this.background.buttonMode = bool;
  };

  public setLongLabel = (label: string): void => {
    this.label.text = label;
    this.label.x = -this.background.width + 150;
  };

  public setNoJackpotDots = (bool: boolean): void => {
    this.counter.setDisplayNumbers(bool);
  };

  public setVisible = (bool: boolean): void => {
    var i = bool ? 1 : 0;
    this.parent.alpha = i;
  };

  public updateJackpotDetails(data: any) {
    this.detailsPanel.updateDetailsValues(data);
  }

  public close = (): void => {
    this.detailsPanel.close();
  };

  // private hideCurrencyandExpand=(bool:boolean):void=>
  // {

  // }

  public setAlignDetailsTo = (alignType: string): void => {
    this.detailsPanel.alignTo(alignType, this.background.width);
  };
  public setDisplayToVertical = (bool: boolean): void => {
    bool;
    if (bool) {
      this.background.texture = PIXI.Texture.fromImage(
        "jackpotCounterBgPortrait.png"
      );
      this.label.x = 5; //(this.background.width)/2-this.label.width/2;
      this.label.y = 0;
      this.label.scale.set(0.5);

      this.jackpotExtentIcon.x =
        this.background.width - this.jackpotExtentIcon.width;
      this.jackpotExtentIcon.alpha = 0;
      this.currency.scale.set(0.75);
      this.currency.x = 5; //this.background.width - this.currency.width;
      this.currency.y = this.label.height;
      this.counter.setPosition(
        this.background.width - this.counter.getTextWidth() - 5,
        0
      );
      this.animation.anchor.set(0, 0.5);
      this.animation.scale.set(0.65, 1);
      this.animation.x = -18;
      this.setHitArea();
    } else {
      // this.background.scale.set(1,1);
      this.background.texture = PIXI.Texture.fromImage("jackpot_txt_bg.png");
      this.label.x = 10;
      this.label.y = 0; //--need to be fixed
      this.label.scale.set(1);
      this.counter.setPosition(
        this.background.width -
          this.counter.getTextWidth() -
          this.currency.width * 1.1,
        0
      );
      this.jackpotExtentIcon.scale.set(1);
      this.jackpotExtentIcon.x =
        this.background.width - this.jackpotExtentIcon.width;
      this.jackpotExtentIcon.alpha = 1;
      this.currency.scale.set(1);
      this.currency.y = 0;
      this.currency.x = this.background.width - this.currency.width;
      this.animation.anchor.set(0.5);
      this.animation.scale.set(1);
      this.animation.x = this.animation.width / 2 - 25;

      this.setHitArea();
    }
  };
}
